import { SURVEY } from '../../constants/action-types';

const initialState = {
  surveys: null,
  filterSurveys: [],
  folders: [],
  currentSurvey: null,
  definition: null,
  theme: null,
  links: null,
  responses: null,
  currentResponse: null,
  sentiment: null,
  exportJob: null,
  alerts: null,
  alertDetail: null,
  alertCount: 0,
  analytics: null,
  questionFrequency: {},
  aiSessions: [],
  aiHistory: null,
  currentAiSession: null,
  surveysLoading: false,
  definitionLoading: false,
  saveInProgress: false,
  error: null,
};

const SurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SURVEY.GET_SURVEYS:
      return { ...state, surveys: action.payload };
    case SURVEY.GET_FILTER_SURVEYS:
      return { ...state, filterSurveys: Array.isArray(action.payload) ? action.payload : (action.payload?.items ?? []) };
    case SURVEY.GET_FOLDERS:
      return { ...state, folders: action.payload };
    case SURVEY.GET_SURVEY:
      return { ...state, currentSurvey: action.payload };
    case SURVEY.GET_DEFINITION:
      return { ...state, definition: action.payload };
    case SURVEY.GET_THEME:
      return { ...state, theme: action.payload };
    case SURVEY.GET_LINKS:
      return { ...state, links: action.payload };
    case SURVEY.GET_RESPONSES:
      return { ...state, responses: action.payload };
    case SURVEY.GET_RESPONSE:
      return { ...state, currentResponse: action.payload };
    case SURVEY.GET_SENTIMENT:
      return { ...state, sentiment: action.payload };
    case SURVEY.SET_EXPORT_JOB:
      return { ...state, exportJob: action.payload };
    case SURVEY.GET_ALERTS:
      return { ...state, alerts: action.payload };
    case SURVEY.GET_ALERT_DETAIL:
      return { ...state, alertDetail: action.payload };
    case SURVEY.GET_ALERT_COUNT:
      return { ...state, alertCount: action.payload };
    case SURVEY.GET_ANALYTICS:
      return { ...state, analytics: action.payload };
    case SURVEY.CLEAR_ANALYTICS:
      return { ...state, analytics: null, questionFrequency: {} };
    case SURVEY.GET_QUESTION_FREQUENCY:
      return {
        ...state,
        questionFrequency: {
          ...state.questionFrequency,
          [action.payload.questionId]: action.payload.data,
        },
      };
    case SURVEY.GET_ALL_QUESTION_FREQUENCIES: {
      const merged = {};
      action.payload.forEach((q) => { merged[q.questionId] = q; });
      return { ...state, questionFrequency: merged };
    }
    case SURVEY.GET_AI_SESSIONS:
      return { ...state, aiSessions: action.payload };
    case SURVEY.GET_AI_HISTORY:
      return { ...state, aiHistory: action.payload };
    case SURVEY.SET_AI_SESSION:
      return { ...state, currentAiSession: action.payload };
    case SURVEY.SET_SURVEYS_LOADING:
      return { ...state, surveysLoading: action.payload };
    case SURVEY.SET_DEFINITION_LOADING:
      return { ...state, definitionLoading: action.payload };
    case SURVEY.SET_SAVE_IN_PROGRESS:
      return { ...state, saveInProgress: action.payload };
    case SURVEY.SET_ERROR:
      return { ...state, error: action.payload };
    case SURVEY.CLEAR_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};

export default SurveyReducer;
